import { render, staticRenderFns } from "./ReturnIcon.vue?vue&type=template&id=2574eaf4&"
import script from "./ReturnIcon.vue?vue&type=script&lang=js&"
export * from "./ReturnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports